(function (Drupal, $, once) {
  Drupal.behaviors.serchResult = {
    attach: function (context) {
      "use strict";
      once("search-results-page-init", ".search-results-page", context).forEach(
        function (element) {
          if ($(element).length) {
            var searchTerm = $(element)
              .find("#views-exposed-form-search-page-1 .form-item-keys input")
              .val();
            $(".view-header>span").text(searchTerm);
          }
          $("#views-exposed-form-search-page-1 .js-form-type-textfield")
            .closest("form")
            .append(
              '<button class="search-clear" type="button" title="Clear the search"></button>'
            );
          $("#views-exposed-form-search-page-1 input[type=text]").on(
            "keyup",
            function () {
              var form = $(this).closest("form");
              if ($(this).val().length > 0) {
                if (!form.children(".search-clear").length) {
                  form.append(
                    '<button class="search-clear" type="button" title="Clear the search"></button>'
                  );
                }
              } else {
                form.children(".search-clear").remove();
              }
            }
          );
          $(document).on(
            "click",
            "#views-exposed-form-search-page-1 .search-clear",
            function (e) {
              e.preventDefault();
              $(this).closest("form").find("input[type=text]").val("").focus();
              $(this).remove();
            }
          );
        }
      ); // once
    },
  };
})(Drupal, jQuery, once);
